import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const SEO = ({
  title = "CauseConnect - Industry's First 24x7 Dedicated AI Copilot for Corporate Philanthropy",
  description = "CauseConnect is the industry's first 24x7 dedicated AI copilot for corporate philanthropy, connecting companies with meaningful CSR opportunities and making a real impact in communities around the world.",
  image = "/images/logo/twoliner-brand.png",
  url = "https://causeconnect.ai",
}: SEOProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
